import moment from "moment";
import { ProjectPerspective, TimeFrequency } from "../../enumerators";
import ProjectRunConfiguration from "../../projectRunConfiguration";
import { ComparedRecord } from "../comparedRecord";
import { AdequacyAggregate } from "./adequacyAggregate";
import { AdequacyDetail } from "./adequacyDetail";

const getComparedSortValue = <T extends AdequacyDetail | AdequacyAggregate>(row: ComparedRecord<T>, perspective: ProjectPerspective): string | number => {
  let rowValue;
  if (perspective === ProjectPerspective.BySpecialty) {
    if (row.oldRecord) {
      rowValue = row.oldRecord.defaultDisplayOrder;
    } else if (row.newRecord) {
      rowValue = row.newRecord.defaultDisplayOrder;
    } else {
      rowValue = row.recordKey;
    }
  } else {
    rowValue = row.recordKey;
  }
  return rowValue;
};

const getTimeString = (runConfiguration: ProjectRunConfiguration, runFrequency: TimeFrequency, overrideDate?: Date): string => {
  let dateString: string;
  if (runConfiguration.isProjected) {
    dateString = "Projected";
  } else if (runConfiguration.isTermed) {
    dateString = "Termed";
  } else if (runConfiguration.isProjectedTermed) {
    dateString = "Projected-Termed";
  } else {
    const d = overrideDate || runConfiguration.dateCreated;
    switch (runFrequency) {
      case TimeFrequency.Monthly:
        dateString = moment.utc(d).local().format("MMMM YYYY");
        break;
      default:
        dateString = moment.utc(d).local().format("MMM DD, 'YY hh:mm A");
        break;
    }
  }
  return dateString;
};

export { getComparedSortValue, getTimeString };
